import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import withStyles from "material-ui/styles/withStyles";

import { db } from '../../../firebase/';

import Button from "components/CustomButtons/Button.jsx";
import GridItemHome from "components/Grid/GridItemHome.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CircularProgress from 'material-ui/Progress/CircularProgress';

import CardFooter from "components/Card/CardFooter.jsx";
import CustomInputRegister from "components/CustomInput/CustomInputRegister.jsx";
import CustomInputSelectNeed from "components/CustomInput/CustomInputSelectNeed.jsx";
import CustomInputSelectDeadline from "components/CustomInput/CustomInputSelectDeadline.jsx";

import { Email, Face, Business, ClearAll, Timer, Web } from "@material-ui/icons";

import InputAdornment from "material-ui/Input/InputAdornment";

import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";


const INITIAL_STATE = {
            name: '',
            email: '',
            company: '', 
            need: '',
            deadline: '',
            projectdetails: '',
            formIsValid: true,
            error: null,
            loading: false
    };

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

class ContactForm extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    onSubmit = (event) => {

    const {
        name,
        email,
        company,
        need,
        deadline,
        loading,
        projectdetails
        } = this.state;

    const { history } = this.props;   

        db.doCreateContact(name, email, company, need, deadline, projectdetails) 
          .then(() => {
                    this.setState(() => ({ ...INITIAL_STATE }));
                if ( loading===false ) {
                    this.setState({loading: !loading});
                setTimeout(function() {
                    this.setState({ loading: false });
                }.bind(this), 
                4000);  // wait 4 seconds, then reset to false
            }
            history.push( '/' );
          })
          .catch(error => {
            this.setState(byPropKey('error', error));
          });

        event.preventDefault();
    }

    checkValidity(value, rules) {
        let isValid = true;
        if (!rules) {
            return true;
        }
        
        if (rules.required) {
            isValid = value.trim() !== '' && isValid;
        }

        if (rules.minLength) {
            isValid = value.length >= rules.minLength && isValid
        }

        if (rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid
        }

        if (rules.isEmail) {
            const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            isValid = pattern.test(value) && isValid
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid
        }

        return isValid;
    }


    render () {
        const {
        name,
        email,
        company,
        need,
        deadline,
        projectdetails,
        loading,
        error
        } = this.state;
        
        const { classes } = this.props;

        const isInvalid =
          company === '' ||
          email === '' ||
          name === '' ||
          projectdetails === '';


        let button = (<Button onClick={this.onSubmit} block color="info" size="md" disabled={isInvalid}>
                          Contact Me
                    </Button>);

        if ( loading ) {
            button = (<Button block color="success" size="md">
                         <CircularProgress className={classes.progress} color="inherit" thickness={5} size={20} />
                         &nbsp;&nbsp;Sending
                    </Button>);
        }

        return (
            <GridItemHome>
                <form className={classes.form} autoComplete="off">
                <CardBody>
                            <CustomInputRegister
                                labelText="Your Name"
                                id="name"
                                formControlProps={{
                                fullWidth: true
                                }}
                                inputProps={{
                                type: "text",
                                endAdornment: (
                                <InputAdornment position="end">
                                  <Face className={classes.inputIconsColor}/>
                                </InputAdornment>
                                )
                                }}
                                value={name}
                                onChange={event => this.setState(byPropKey('name', event.target.value))} />
                            <CustomInputRegister
                                labelText="Email"
                                id="email"
                                formControlProps={{
                                fullWidth: true
                                }}
                                inputProps={{
                                type: "email",
                                endAdornment: (
                                <InputAdornment position="end">
                                  <Email className={classes.inputIconsColor}/>
                                </InputAdornment>
                                )
                                }}
                                value={email}
                                onChange={event => this.setState(byPropKey('email', event.target.value))} />
                            <CustomInputRegister
                                labelText="Company / Organisation"
                                id="company"
                                formControlProps={{
                                fullWidth: true
                                }}
                                inputProps={{
                                type: "text",
                                endAdornment: (
                                <InputAdornment position="end">
                                  <Business className={classes.inputIconsColor}/>
                                </InputAdornment>
                                )
                                }}
                                value={company}
                                onChange={event => this.setState(byPropKey('company', event.target.value))} />
                            <CustomInputSelectNeed
                                labelText="Need a ..."
                                formControlProps={{
                                fullWidth: true
                                }}
                                inputProps={{
                                id: 'need',
                                endAdornment: (
                                <InputAdornment position="end">
                                  <Web className={classes.inputIconsColor}/>
                                </InputAdornment>
                                )
                                }}
                                value={need}
                                onChange={event => this.setState(byPropKey('need', event.target.value))} />
                            <CustomInputSelectDeadline
                                labelText="Deadline"
                                formControlProps={{
                                fullWidth: true
                                }}
                                inputProps={{
                                id:'deadline',
                                endAdornment: (
                                <InputAdornment position="end">
                                  <Timer className={classes.inputIconsColor}/>
                                </InputAdornment>
                                )
                                }}
                                value={deadline}
                                onChange={event => this.setState(byPropKey('deadline', event.target.value))} />
                            <CustomInputRegister
                                labelText="Tell me about your project"
                                id="projectdetails"
                                formControlProps={{
                                fullWidth: true
                                }}
                                inputProps={{
                                type: "text",
                                multiline: true,
                                rows: 3,
                                endAdornment: (
                                <InputAdornment position="end">
                                  <ClearAll className={classes.inputIconsColor}/>
                                </InputAdornment>
                                )
                                }}
                                value={projectdetails}
                                onChange={event => this.setState(byPropKey('projectdetails', event.target.value))} />
                        </CardBody>
                    </form>
                { error && <p className={classes.textCenter}>{error.message}</p> }
                <CardFooter className={classes.cardFooter}>
                    {button}
                </CardFooter>
            </GridItemHome>
        );
    }
}



export default withRouter(withStyles(componentsStyle)(ContactForm));


// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/ContactForm.jsx